import React, { useEffect } from 'react';
import { Lightbox } from './styles';

// Full-screen image lightbox. Click anywhere or press ESC to close.
const MediaViewerV2 = ({ src, onClose }) => {
  useEffect(() => {
    if (!src) return undefined;
    const onKey = (e) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [src, onClose]);

  if (!src) return null;

  return (
    <Lightbox onClick={onClose}>
      <img src={src} alt="" onClick={(e) => e.stopPropagation()} />
    </Lightbox>
  );
};

export default MediaViewerV2;
